import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminPage() {
  const [qaId, setQaId] = useState('');
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSearch = async () => {
    try {
      const response = await fetch(`https://www.cognospring.site/api/qa/${qaId}`);
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || '查询失败');
      setMessage('查询成功！\n'+data);
    } catch (err) {
      setMessage(err.message);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`https://www.cognospring.site/api/update_qa/${qaId}`, {
        method: 'PUT',
        headers: {'Content-Type': 'application/json'},  // 设置正确的Content-Type
        body: JSON.stringify({  // 发送JSON格式数据
          question: question,
          answer: answer
        })
      });
      
      if (!response.ok) throw new Error('更新失败');
      setMessage('更新成功！');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      setMessage(err.message);
    }
  };

  return (
    <div className="admin-container">
      <button onClick={() => navigate('/')} className="home-button">返回首页</button>
      <h2>QA对管理</h2>
      
      <form onSubmit={handleSubmit}>
        <div className="search-section">
          <div className="form-group">
            <label>题目ID：</label>
            <input
              type="number"
              value={qaId}
              onChange={(e) => setQaId(e.target.value)}
            />
            <button type="button" onClick={handleSearch} className="search-btn">
              查询
            </button>
          </div>
        </div>

        <div className="form-group">
          <label>问题：</label>
          <textarea
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>答案：</label>
          <textarea
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="submit-btn">提交修改</button>
      </form>

      {message && (
        <div className={`message ${message.includes('成功') ? 'success' : 'error'}`}>
          {message.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              {index < message.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
}